function tenantRoute(routeName, ...params) {
  const tenant = window.route().params.tenant;

  if (params.length === 1 && typeof params[0] === 'object' && !Array.isArray(params[0])) {
    return window.route(routeName, { tenant, ...params[0] });
  }

  return window.route(routeName, [tenant, ...params]);
}

window.tenantRoute = tenantRoute;
